import styled from 'styled-components';

const DropdownMenuWrapper = styled.div`
  display: inline-block;
`;

export default {
  DropdownMenuWrapper,
};
